import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';
import { Action } from '../../models/action';

export class GoogleActionDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.GOOGLEACTION, apiHelper);
  }

  public loadCampaigns(integrationId: string, showPaused: boolean): Observable<any> {
    let url =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/campaigns?integrationId=${integrationId}${showPaused ? '&showPaused' : ''}`;
    let headers = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<any>(url, 'GET', null, null, headers, null);
  }

}
